export class ConvoPreviewMessageGroup {
    messages: any[];

    constructor(messages: any[]) {
        this.messages = messages;
    }
}
